import { NgModule } from "@angular/core";
import {
  MatButtonModule,
  MatIconModule,
  MatFormFieldModule,
  MatInputModule,
  MatDatepickerModule,
  MatNativeDateModule,
  MatCheckboxModule,
  MatSidenavModule,
  MatToolbarModule,
  MatListModule,
  MatExpansionModule,
  MatTabsModule,
  MatCardModule,
  MatDialogModule,
  MatTreeModule,
  MatTableModule,
  MatMenuModule,
  MatSelectModule,
  MatProgressSpinnerModule,
  MatProgressBarModule,
  MatTooltipModule,
  DateAdapter,
  MAT_DATE_FORMATS,
  MatSortModule,
  MatPaginatorModule,
  MatRadioModule,
  MatAutocompleteModule
} from "@angular/material";
import { FormsModule } from "@angular/forms";
import { CustomDateAdapter } from "./common/widgets/date-format";
import { AppDateAdapter, APP_DATE_FORMATS } from "./common/widgets/adapters/date.adapter";
// import { DateFormat } from "./common/widgets/date-format";

const MY_DATE_FORMATS = {
  parse: {
    dateInput: { month: "short", year: "numeric", day: "numeric" }
  },
  display: {
    dateInput: "input",
    monthYearLabel: { year: "numeric", month: "short" },
    dateA11yLabel: { year: "numeric", month: "long", day: "numeric" },
    monthYearA11yLabel: { year: "numeric", month: "long" }
  }
};

@NgModule({
  imports: [
    MatButtonModule,
    MatIconModule,
    MatFormFieldModule,
    MatInputModule,
    MatDatepickerModule,
    MatNativeDateModule,
    MatCheckboxModule,
    MatSidenavModule,
    MatToolbarModule,
    MatListModule,
    MatExpansionModule,
    MatTabsModule,
    MatCardModule,
    MatDialogModule,
    FormsModule,
    MatTreeModule,
    MatTableModule,
    MatMenuModule,
    MatSelectModule,
    MatProgressSpinnerModule,
    MatProgressBarModule,
    MatTooltipModule,
    MatSortModule,
    MatPaginatorModule,
    MatRadioModule,
    MatAutocompleteModule
  ],
  exports: [
    MatButtonModule,
    MatIconModule,
    MatFormFieldModule,
    MatInputModule,
    MatDatepickerModule,
    MatNativeDateModule,
    MatCheckboxModule,
    MatSidenavModule,
    MatToolbarModule,
    MatListModule,
    MatExpansionModule,
    MatTabsModule,
    MatCardModule,
    MatDialogModule,
    FormsModule,
    MatTreeModule,
    MatTableModule,
    MatMenuModule,
    MatSelectModule,
    MatProgressSpinnerModule,
    MatProgressBarModule,
    MatTooltipModule,
    MatSortModule,
    MatPaginatorModule,
    MatRadioModule,
    MatAutocompleteModule
  ],
  providers: [
    {
      provide: DateAdapter,
      // useClass: CustomDateAdapter,
      useClass: AppDateAdapter,
    },
    {
      provide: MAT_DATE_FORMATS,
      // useValue: MY_DATE_FORMATS,
      useValue: APP_DATE_FORMATS,
    }
  ]
})
export class MaterialModule {
  // constructor(private dateAdapter: DateAdapter<Date>) {
  //   dateAdapter.setLocale("en-in"); // DD/MM/YYYY
  // }
}
